<template>
  <div style="width: 100%;height: 100%">
    <img v-show="currState && option.attribute.urls[currState]" style="width: 100%;height: 100%;" :src="fileUrl + option.attribute.urls[currState]"/>
  </div>
</template>

<script>
import {fileUrl} from "/env";
import {getDataJson, pollingRefresh,hasNonEmptyValues,hasProperty} from "@/utils/refresh-cpt-data";

export default {
  name: "cpt-img-state",
  props:['option','components','current'],
  data(){
    return {
      fileUrl,
      uuid: null,
      currState:'0',
      cptData: {},
      newData:"",
      jsFunFlag:false,
    }
  },
  computed: {
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    },
  },
  watch: {
    "current.cptShow"(val) {
      console.log('text-show-', val);
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    }
  },
  created() {
    this.uuid = require('uuid').v1();
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }
    this.randomState()
  },
  methods: {
    randomState(){
      const that = this;
      const stateList = ['default','used','alert','hitch']
      setInterval(() => {
        let index = Math.floor(Math.random()*(4))
        that.currState = stateList[index]
      },2000)
    },
    refreshCptData(cptDataForm = this.option.cptDataForm,paras) {
      pollingRefresh(this.uuid, cptDataForm, () => this.loadData(cptDataForm,paras),this.components)
    },
    loadData(cptDataForm,paras) {
      const that = this;
      getDataJson(cptDataForm,paras,(res)=> {
        that.newData = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
        that.jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res,'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
        that.processData(cptDataForm,that.newData,that.jsFunFlag)
      })
    },
    processData(cptDataForm,res,jsFunFlag,isFromGrid){
      // 第一层判断 如果选择数据集
      if(cptDataForm.dataSource == '4') {
            if(this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid')return 

        // 第二层判断 ，如果没有配转换脚本
        if(jsFunFlag) { // 没有全部配置映射字段
        //判断此控件在九宫格里面就不请求数据
            if(hasNonEmptyValues(this.option.attribute.cptTableData)) {
            const dataKey = this.option.attribute.cptTableData;
          // 创建一个新的数组用于存储结果
            let newres = [];
            let newObj = {...res[0]};
          // 如果dataKey中的value有值并且在newObj对象中有对应的值
            // if (dataKey[0].value && newObj[dataKey[0].value]) {
              newObj[dataKey[0].namekey] = newObj[dataKey[0].value];
            // }
            newres.push(newObj);
            // console.log(newres,'新数组');
            this.cptData = newres[0]; 
          }
          } else { // 如果配置了转换脚本
            this.cptData = res;
          }
      } else { // 不是数据集类型，是静态数据
        this.cptData = res;
      } 
       console.log(this.cptData,'this.cptData')
        let fil = this.cptData.value || this.cptData.state
        this.currState = fil ? fil+'':'0'
   },
  }
}
</script>

<style scoped>

</style>
